import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button, Icon } from '@toggle/design-system';
import React from 'react';

import * as S from './WebsiteCard.styles';

interface WebsiteCardProps {
  id: string;
  title: string;
  url: string;
  favicon: string;
  handleRemove?: (id: string) => void;
}

export const WebsiteCard = ({
  id,
  title,
  url,
  favicon,
  handleRemove,
}: WebsiteCardProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  
  return (
    <S.CardWrapper ref={setNodeRef} style={style}>
      <S.DragHandle {...attributes} {...listeners}>
        <Icon iconName="GripDotsVertical" size={16} />
      </S.DragHandle>
      <S.Content $onlyUrl={!title}>
        <S.Favicon src={favicon} alt={title} />
        <S.InfoWrapper>
          <S.Title>{title}</S.Title>
          <S.Url>{url}</S.Url>
        </S.InfoWrapper>
      </S.Content>
      <Button
        iconName="Close"
        size="xsmall"
        variant="empty"
        onClick={() => {
          handleRemove?.(id);
        }}
      />
    </S.CardWrapper>
  );
};
